import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { reducer } from './reducer';
import { StudioDetailStoreEffects } from './effects';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature('studio-detail', reducer),
        EffectsModule.forFeature([StudioDetailStoreEffects]),
    ],
    providers: [],
})
export class StudioDetailStoreModule { }
